<template>
  <div class="container">
    <header>
      <nav>
        <router-link class="js" to="/course-planning/elementary-school">
          <img src="../assets/js.svg" />
        </router-link>
        <router-link class="jc" to="/course-planning/junior-high-school">
          <img src="../assets/jc.svg" />
        </router-link>
        <router-link class="jk" to="/course-planning/high-school">
          <img src="../assets/jk.svg" />
        </router-link>
      </nav>
      <img class="cover" src="../assets/course-planning-header-cover.svg" />
    </header>
    <nav class="schools">
      <SubNavItem
        class="js"
        to="/course-planning/elementary-school"
        text="國小"
      />
      <SubNavItem
        class="jc"
        to="/course-planning/junior-high-school"
        text="國中"
      />
      <SubNavItem class="jk" to="/course-planning/high-school" text="高中" />
    </nav>
    <router-view />
  </div>
</template>

<script>
import SubNavItem from "@/components/SubNavItem.vue";

export default {
  components: {
    SubNavItem
  },
  data() {
    return {
      schoolLevel: "elementary-school"
    };
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding-bottom: 40px;
}

header {
  width: 100%;
  padding-top: 30px;
  background: url("../assets/course-planning-header-bg.svg") no-repeat;
  background-position: top center;
  background-size: cover;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  margin-bottom: 25px;

  .cover {
    display: block;
    position: absolute;
    bottom: -1px;
    width: 101%;
    height: auto;
  }

  nav {
    position: relative;
    bottom: -14px;
    display: grid;
    grid-template-areas: ". . .";
    justify-content: center;
    align-items: end;
    width: 100%;
    grid-gap: 60px;

    a {
      display: block;

      img {
        opacity: 0.3;
        width: 100%;
        height: auto;
      }

      &.router-link-active img {
        opacity: 1;
      }
    }
  }
}

nav.schools {
  max-width: 620px;
  display: grid;
  grid-template-areas: ". . .";
  justify-content: center;
  grid-gap: 33%;
  margin: auto;
}

@media (max-width: 480px) {
  header {
    nav {
      grid-gap: 20px !important;
      width: 50% !important;
      margin: auto;
    }
  }

  nav.schools {
    grid-gap: 13% !important;
  }
}
</style>
